import { observer } from "mobx-react-lite";
import { useAlbumStore, useProfilStore } from "../stores/useStore";
import OngletLeft from "../components/general/OngletLeft"
import Header from "../components/general/Header"
import "../style/Admin.css"
import { useEffect } from "react";
import { useNavigate } from "react-router";
import CreateAlbum from "../components/admin/CreateAlbum"

const Admin = observer(() => {
  const profilStore = useProfilStore();
  const navigate = useNavigate();

  const ongletList = [
    {
        name : "Ajouter/modifier un album",
        content : <CreateAlbum></CreateAlbum>,
        id : 0
    },
    {
        name : "Ajouter/modifier un Groupe",
        content : <p>Contenu 2</p>,
        id : 1
    },
    {
        name : "Ajouter/modifier un compte",
        content : <p>Contenu 3</p>,
        id : 2
    },
    {
        name : "Ajouter/modifier une photo de Profil",
        content : <p>Contenu 4</p>,
        id : 3
    }
]

  useEffect(()=>{
    if (!profilStore.admin) {
      navigate("/profil");
    }
  }, [])


  return (
    <div className="admin_main">
      <Header admin={profilStore.admin} connected={profilStore.isConnected} imageProfil={profilStore.isConnected&&profilStore.profilPicture?profilStore.profilPicture:undefined}/>
      <main className="admin_content">
        <OngletLeft ongletList={ongletList}></OngletLeft>
      </main>
    </div>
  );
});

export default Admin;
